import { HelpRhombusIcon } from './HelpRhombusIcon';

/**
 * author: Michael Irigoyen
 * id FC7F2A59-0296-45CC-966D-EF69FB042DD9
 * name help-rhombus
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-rhombus.svg
 * tags
 */
export const QuestionMarkRhombusIcon = HelpRhombusIcon;
export default QuestionMarkRhombusIcon